document.addEventListener('DOMContentLoaded', function () {

  /* ─────────────────────────────────────────────────────────────
     REFS
  ───────────────────────────────────────────────────────────── */
  const bar      = document.getElementById('nk-floating-search');
  const form     = document.getElementById('nk-floating-search-form');
  const input    = document.getElementById('nk-floating-search-input');
  const closeBtn = document.getElementById('nk-floating-search-close');
  const smartPanel = document.getElementById('nk-smart-search-panel');
  if (!bar || !form || !input || !closeBtn) return;

  const ghost  = document.getElementById('nk-tw-ghost');
  const twText = document.getElementById('nk-tw-text');

  /* ─────────────────────────────────────────────────────────────
     TYPEWRITER CONFIG
  ───────────────────────────────────────────────────────────── */
  const PHRASES = [
    "Search Products, Pages, FAQs..."
  ];

  /* Original typewriter phrases — commented out for now
  const PHRASES = [
    "Gift for a 7-year-old boy who loves Thor...",
    "Sarcastic notepad for an office friend...",
    "Mandala and boho design products for a Barbie fan...",
    "Premium Pushpa fandom merchandise...",
    "A thoughtful custom board game for family night...",
    "Custom dynamic novel starring my daughter...",
    "Studio-grade canvas prints of mountain landscapes...",
    "Elegant and minimalist accessories for mom...",
    "Funny personalized coffee mug for my boss...",
    "High-quality cotton tees with custom pet portraits...",
    "Premium boutique gifts under ₹2000...",
    "Sci-fi themed desk accessories for my workspace...",
    "Personalized leather travel wallet with initials...",
    "Vintage style travel posters for the living room...",
    "Aesthetic desk setup items for remote work..."
  ];
  */

  const TYPE_SPEED     = 50;
  const DELETE_SPEED   = 30;
  const PAUSE_FULL     = 2500;
  const PAUSE_EMPTY    = 200;
  const AUTO_EXPAND_MS = 3000;

  /* ─────────────────────────────────────────────────────────────
     PILL / EXPAND STATE
  ───────────────────────────────────────────────────────────── */
  let isExpanded  = false;
  let isFocused   = false;
  let phraseIdx   = 0;
  let charIdx     = 0;
  let isTyping    = true;
  let twTimer     = null;
  let autoTimer   = null;
  let lastScrollY = window.scrollY;

  function collapse() {
    if (!isExpanded) return;
    isExpanded = false;
    isFocused  = false;
    bar.classList.add('is-pill');
    stopTW();
    twText.textContent = '';
    ghost.style.display = '';
    input.classList.remove('nk-input-active');
    input.blur();
    input.value = '';
    panelClose();
    scheduleAutoExpand();
  }

  function expand() {
    if (isExpanded) return;
    isExpanded = true;
    bar.classList.remove('is-pill');
    bar.classList.remove('is-hidden');
    startTW();
  }

  function scheduleAutoExpand() {
    clearTimeout(autoTimer);
    autoTimer = setTimeout(function () {
      if (!isExpanded) expand();
    }, AUTO_EXPAND_MS);
  }

  window.addEventListener('scroll', function () {
    const y     = window.scrollY;
    const delta = y - lastScrollY;
    lastScrollY = y;
    if (Math.abs(delta) > 4 && isExpanded && !isFocused) collapse();
  }, { passive: true });

  /* ─────────────────────────────────────────────────────────────
     TYPEWRITER ENGINE
  ───────────────────────────────────────────────────────────── */
  function startTW() { if (twText) twText.textContent = PHRASES[0]; }
  function stopTW()  { clearTimeout(twTimer); }

  /* Original typewriter engine — commented out, replaced with static text
  function startTW() { stopTW(); charIdx = 0; isTyping = true; tick(); }
  function stopTW()  { clearTimeout(twTimer); }

  function tick() {
    if (isFocused) return;
    const phrase = PHRASES[phraseIdx];
    if (isTyping) {
      twText.textContent = phrase.slice(0, charIdx);
      if (charIdx < phrase.length) {
        charIdx++;
        twTimer = setTimeout(tick, TYPE_SPEED);
      } else {
        twTimer = setTimeout(function () { isTyping = false; tick(); }, PAUSE_FULL);
      }
    } else {
      if (charIdx > 0) {
        charIdx--;
        twText.textContent = phrase.slice(0, charIdx);
        twTimer = setTimeout(tick, DELETE_SPEED);
      } else {
        phraseIdx = (phraseIdx + 1) % PHRASES.length;
        isTyping  = true;
        twTimer   = setTimeout(tick, PAUSE_EMPTY);
      }
    }
  }
  */

  /* ─────────────────────────────────────────────────────────────
     PANEL OPEN / CLOSE
  ───────────────────────────────────────────────────────────── */
  function panelOpen() {
    smartPanel?.classList.add('is-open');
  }

  function panelClose() {
    smartPanel?.classList.remove('is-open');
    showEmptyState();
  }

  /* ─────────────────────────────────────────────────────────────
     FOCUS INPUT
  ───────────────────────────────────────────────────────────── */
  function focusInput() {
    isFocused = true;
    stopTW();
    twText.textContent = '';
    ghost.style.display = 'none';
    input.classList.add('nk-input-active');
    input.focus();
    panelOpen();
    showEmptyState();
  }

  /* ─────────────────────────────────────────────────────────────
     CLICK / BLUR
  ───────────────────────────────────────────────────────────── */
  bar.addEventListener('click', function (e) {
    if (!isExpanded) {
      clearTimeout(autoTimer);
      expand();
      // Small delay so the pill→bar CSS transition completes before we
      // add nk-input-active and call .focus() — otherwise the input is
      // still display:none and browsers ignore the focus() call.
      setTimeout(focusInput, 60);
      return;
    }
    if (e.target.closest('.nk-floating-search__button, .nk-floating-search__close')) return;
    if (!isFocused) focusInput();
  });

  input.addEventListener('blur', function () {
    setTimeout(function () {
      if (input.value.trim() === '') {
        isFocused = false;
        input.classList.remove('nk-input-active');
        panelClose();
        ghost.style.display = '';
        charIdx  = 0;
        isTyping = true;
        tick();
      }
    }, 200);
  });

  input.addEventListener('focus', function () {
    bar.classList.remove('is-hidden');
  });

  /* ─────────────────────────────────────────────────────────────
     STORAGE / CLOSE BUTTON
  ───────────────────────────────────────────────────────────── */
  const STORAGE_KEY = 'nkFloatingSearchClosed';
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    bar.classList.add('is-hidden');
  }

  closeBtn.addEventListener('click', function () {
    bar.classList.add('is-hidden');
    sessionStorage.setItem(STORAGE_KEY, 'true');
    stopTW();
  });

  /* ─────────────────────────────────────────────────────────────
     PANEL STATE MACHINE
  ───────────────────────────────────────────────────────────── */
  function el(id) { return document.getElementById(id); }

  function showEmptyState() {
    el('nk-fs-empty-state').hidden  = false;
    el('nk-fs-loading').hidden      = true;
    el('nk-fs-results-state').hidden = true;
  }

  function showLoadingState() {
    el('nk-fs-empty-state').hidden   = true;
    el('nk-fs-loading').hidden       = false;
    el('nk-fs-results-state').hidden = true;
  }

  function showResultsState() {
    el('nk-fs-empty-state').hidden   = true;
    el('nk-fs-loading').hidden       = true;
    el('nk-fs-results-state').hidden = false;
  }

  /* ─────────────────────────────────────────────────────────────
     LOCAL PAGE SEARCH (from Liquid-injected data — instant, no API)
  ───────────────────────────────────────────────────────────── */
  let _cachedPages = null;

  function getLocalPages() {
    if (_cachedPages) return _cachedPages;
    try {
      const el = document.getElementById('nk-pages-data');
      _cachedPages = el ? JSON.parse(el.textContent).filter(Boolean) : [];
      console.log('[NijikartSearch] local pages loaded:', _cachedPages.length, _cachedPages.map(function(p){ return p.title; }));
    } catch (e) {
      console.error('[NijikartSearch] page data parse error:', e);
      _cachedPages = [];
    }
    return _cachedPages;
  }

  // Pages that are internal, B2B, or template pages — never show in customer Help & Guides
  var _INTERNAL_PAGE_RE = /homepage|productpage|waitlist|seller.profile|brands.ad|brands.white|toycra|ugc.term|schedule.a.meet|afilliate|affiliate|ambassador|all.collection|giveaway|me.commerce|producer|production.partner|collabs|business.to.business|b2b|manage.sub|subscription|seller.profile/i;

  // Keywords that identify genuinely useful customer-facing help pages (shown as defaults)
  var _PRIORITY_HELP_RE = /faq|frequently.asked|how.it.work|contact|knowledge.base|safety|protection|oops|buyer.guarantee|heart.protected|about.us|our.story|for.buyers|how.we.work/i;

  function _customerPages() {
    // Filter internal pages and deduplicate by URL
    var seen = {};
    return getLocalPages().filter(function (p) {
      if (_INTERNAL_PAGE_RE.test(p.title)) return false;
      if (seen[p.url]) return false;
      seen[p.url] = true;
      return true;
    });
  }

  function _defaultHelpPages() {
    var pages = _customerPages();
    // Priority: FAQ, How it Works, Contact, Buyer Safety, Knowledge Base first
    var priority = pages.filter(function (p) { return _PRIORITY_HELP_RE.test(p.title); });
    var rest     = pages.filter(function (p) { return !_PRIORITY_HELP_RE.test(p.title); });
    return priority.concat(rest).slice(0, 4);
  }

  function searchLocalPages(query) {
    var pages = _customerPages();
    if (!pages.length) return [];
    var words = query.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 2; });
    if (!words.length) return [];
    var scored = pages.map(function (p) {
      var title = p.title.toLowerCase();
      var desc  = (p.desc || '').toLowerCase();
      var titleHits = words.filter(function (w) { return title.includes(w); }).length;
      var descHits  = words.filter(function (w) { return desc.includes(w); }).length;
      // Track which words matched in the body (not title) for deep-link targeting
      var descMatchedWords = words.filter(function (w) { return desc.includes(w); });
      return { p: p, score: titleHits * 3 + descHits, descWords: descMatchedWords };
    }).filter(function (s) { return s.score > 0; })
      .sort(function (a, b) { return b.score - a.score; });

    return scored.slice(0, 4).map(function (s) {
      var result = Object.assign({}, s.p);
      // Deep-link using Text Fragment (#:~:text=) so browser scrolls to and highlights
      // the matched content on the page. Use body match words (not title — title match
      // means the whole page is about that topic, no need to anchor to a specific spot).
      if (s.descWords.length > 0) {
        var desc = s.p.desc || '';
        var w = s.descWords[0];
        var idx = desc.toLowerCase().indexOf(w);
        var phrase = idx >= 0
          ? desc.slice(idx, idx + Math.min(w.length + 20, 40))
          : w;
        result = Object.assign({}, result, { url: addTextFragment(result.url, phrase) });
      }
      return result;
    });
  }

  /* ─────────────────────────────────────────────────────────────
     SHOPIFY PREDICTIVE SEARCH
  ───────────────────────────────────────────────────────────── */
  async function fetchShopifyResults(query) {
    try {
      const url = `/search?q=${encodeURIComponent(query)}&type=product,collection,article,page&view=ajax`;
      const res = await fetch(url);
      if (!res.ok) return { products: [], collections: [], articles: [], pages: [] };
      const raw = await res.json();
      // New format: {products, collections, articles, pages}
      // Fallback: old format was a plain array of products
      if (Array.isArray(raw)) {
        return {
          products: raw.slice(0, 6),
          collections: [],
          articles: [],
          pages: [],
        };
      }
      return {
        products:    (raw.products    || []).slice(0, 6),
        collections: (raw.collections || []).slice(0, 4),
        articles:    (raw.articles    || []).slice(0, 3),
        pages:       (raw.pages       || []).slice(0, 3),
      };
    } catch (e) {
      return { products: [], collections: [], articles: [], pages: [] };
    }
  }

  function formatPrice(raw) {
    if (!raw) return '';
    const num = parseFloat(raw);
    if (isNaN(num)) return '';
    return '₹' + Math.round(num).toLocaleString('en-IN');
  }

  /* ─────────────────────────────────────────────────────────────
     RENDERERS
  ───────────────────────────────────────────────────────────── */
  function renderProducts(products, searchText) {
    const section   = el('nk-fs-products-section');
    const grid      = el('nk-fs-product-grid');
    const viewAll   = el('nk-fs-view-all');
    const noResults = el('nk-fs-no-results');
    const countEl   = el('nk-fs-product-count');

    if (!products.length) {
      section.hidden   = true;
      noResults.hidden = false;
      return;
    }

    noResults.hidden = true;
    if (viewAll) viewAll.href = `/search?q=${encodeURIComponent(searchText)}&type=product&options[prefix]=last`;
    if (countEl) countEl.textContent = `(${products.length})`;

    grid.innerHTML = products.map(function (p) {
      const price = formatPrice(p.price || p.price_min);
      const imgSrc = p.image || '';
      const thumb = imgSrc
        ? `<img src="${escHtml(imgSrc)}" alt="${escHtml(p.title)}" loading="lazy" class="nk-fs-result-row__thumb">`
        : `<span class="nk-fs-result-row__thumb nk-fs-result-row__thumb--placeholder">🛍️</span>`;
      return `<li>
        <a href="${escHtml(p.url)}" class="nk-fs-result-row">
          ${thumb}
          <span class="nk-fs-result-row__body">
            <span class="nk-fs-result-row__title">${escHtml(p.title)}</span>
            <span class="nk-fs-result-row__path">${price ? price : escHtml(p.url)}</span>
          </span>
          <span class="nk-fs-result-row__badge nk-fs-result-row__badge--product">product</span>
        </a>
      </li>`;
    }).join('');

    section.hidden = false;
  }

  function renderCollections(collections) {
    const section  = el('nk-fs-collections-section');
    const grid     = el('nk-fs-collections-grid');
    const countEl  = el('nk-fs-collections-count');

    if (!collections.length) { section.hidden = true; return; }

    if (countEl) countEl.textContent = '(' + collections.length + ')';

    grid.innerHTML = collections.map(function (c) {
      const imgSrc = c.image || '';
      const thumb = imgSrc
        ? `<img src="${escHtml(imgSrc)}" alt="${escHtml(c.title)}" loading="lazy" class="nk-fs-result-row__thumb">`
        : `<span class="nk-fs-result-row__thumb nk-fs-result-row__thumb--placeholder">🗂️</span>`;
      return `<li>
        <a href="${escHtml(c.url)}" class="nk-fs-result-row">
          ${thumb}
          <span class="nk-fs-result-row__body">
            <span class="nk-fs-result-row__title">${escHtml(c.title)}</span>
            <span class="nk-fs-result-row__path">${escHtml(c.url)}</span>
          </span>
          <span class="nk-fs-result-row__badge nk-fs-result-row__badge--collection">collection</span>
        </a>
      </li>`;
    }).join('');

    section.hidden = false;
  }

  function renderPages(pages) {
    var section  = el('nk-fs-help-section');
    var list     = el('nk-fs-help-list');
    var countEl  = el('nk-fs-help-count');
    if (!section || !list) return;
    if (!pages.length) { section.hidden = true; return; }

    if (countEl) countEl.textContent = '(' + pages.length + ')';

    list.innerHTML = pages.map(function (p) {
      var isArticle = p.type === 'article';
      var icon  = isArticle ? '📰' : '❓';
      var badge = isArticle ? 'Article' : 'Help';
      var category = p.category ? escHtml(p.category) : (isArticle ? 'Articles' : 'Pages');
      return '<li>'
        + '<a href="' + escHtml(p.url) + '" class="nk-fs-result-row">'
        +   '<span class="nk-fs-result-row__icon">' + icon + '</span>'
        +   '<span class="nk-fs-result-row__body">'
        +     '<span class="nk-fs-result-row__title">' + escHtml(p.title) + '</span>'
        +     '<span class="nk-fs-result-row__path">' + escHtml(p.url) + '</span>'
        +   '</span>'
        +   '<span class="nk-fs-result-row__badge nk-fs-result-row__badge--help">' + category + '</span>'
        + '</a>'
        + '</li>';
    }).join('');

    section.hidden = false;
  }

  function renderInterpretation(data, query) {
    NkSmartSearch.renderInterpretationPanel(data, query, {
      root:            'nk-fs-meta-row',
      interpreted:     'nk-fs-interpreted',
      interpretedText: 'nk-fs-interpreted-text',
      language:        'nk-fs-language',
      languageText:    'nk-fs-language-text',
      didYouMean:      'nk-fs-did-you-mean',
      didYouMeanText:  'nk-fs-did-you-mean-text',
      corrections:     'nk-fs-corrections',
      correctionsText: 'nk-fs-corrections-text',
      refineSection:   'nk-fs-refine-section',
      refineList:      'nk-fs-refine-chip-list',
      relatedSection:  'nk-fs-related-section',
      relatedList:     'nk-fs-related-chip-list'
    });
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Decode HTML entities left behind by Liquid's strip_html filter
  // (e.g. &amp; → &, &amp;amp; → &, &quot; → ")
  function decodeEntities(str) {
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  // Add a #:~:text= fragment to a URL so the browser scrolls to and highlights
  // the search term on the destination page (Chrome/Edge Text Fragments spec).
  function addTextFragment(url, phrase) {
    if (!phrase) return url;
    var clean = decodeEntities(phrase).trim();
    if (!clean) return url;
    // Strip any trailing partial word that got cut off mid-word
    clean = clean.replace(/\s+\S*$/, '').trim();
    if (!clean) return url;
    return url + '#:~:text=' + encodeURIComponent(clean);
  }

  /* ─────────────────────────────────────────────────────────────
     MAIN SEARCH — Shopify predictive + local pages only.
     No AI call here — AI runs only on the /search results page
     after the user presses Enter, which eliminates per-keystroke
     Gemini API costs.
  ───────────────────────────────────────────────────────────── */
  async function runSearch(query) {
    showLoadingState();

    const shopifyData = await fetchShopifyResults(query);

    // Merge Shopify articles/pages with local help pages, dedupe by URL
    var localPages = searchLocalPages(query);
    var shopifyPages = (shopifyData.articles || []).concat(shopifyData.pages || []);
    var seenUrls = new Set(localPages.map(function (p) { return p.url; }));
    // Shopify API results don't go through searchLocalPages so they get no fragment.
    // Add one using the first matched query word so they also deep-link.
    var fragWords = query.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 2; });
    shopifyPages.forEach(function (p) {
      if (!seenUrls.has(p.url)) {
        var fragPage = fragWords.length
          ? Object.assign({}, p, { url: addTextFragment(p.url, fragWords[0]) })
          : p;
        localPages.push(fragPage);
        seenUrls.add(p.url);
      }
    });

    showResultsState();
    renderProducts(shopifyData.products, query);
    renderCollections(shopifyData.collections);
    renderPages(localPages);

    // Browse-all and view-all links use raw query (AI will refine on results page)
    const browseLink = el('nk-fs-browse-link');
    const viewAll = el('nk-fs-view-all');
    const searchUrl = `/search?q=${encodeURIComponent(query)}&options[prefix]=last`;
    if (browseLink) browseLink.href = searchUrl;
    if (viewAll) viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last`;
  }

  /* ─────────────────────────────────────────────────────────────
     INPUT HANDLER (debounced, min 3 chars)
  ───────────────────────────────────────────────────────────── */
  let searchTimer;

  input.addEventListener('input', function () {
    const query = input.value.trim();
    clearTimeout(searchTimer);

    if (!query || query.length < 3) {
      showEmptyState();
      return;
    }

    searchTimer = setTimeout(async function () {
      try {
        await runSearch(query);
      } catch (err) {
        console.error('Smart search error:', err);
        showEmptyState();
      }
    }, 500);
  });

  /* ─────────────────────────────────────────────────────────────
     FORM SUBMIT
  ───────────────────────────────────────────────────────────── */
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    const query = input.value.trim();
    if (!query) { input.focus(); return; }

    // Fast path: client-side vocabulary match — no network call, instant navigation
    const instantUrl = NkSmartSearch.buildInstantUrl && NkSmartSearch.buildInstantUrl(query);
    if (instantUrl) {
      window.location.href = instantUrl;
      return;
    }

    // Slow path: call AI with a 3 s cap so the bar never blocks indefinitely.
    // On timeout we fall back to a plain search URL; the search page overlay
    // will call AI and apply filters once the page has loaded.
    form.classList.add('is-loading');
    try {
      const data = await Promise.race([
        NkSmartSearch.smartSearch(query),
        new Promise(function (_, reject) { setTimeout(function () { reject(new Error('timeout')); }, 3000); })
      ]);

      try {
        sessionStorage.setItem('nk_ai_result', JSON.stringify({ q: query.toLowerCase(), data, ts: Date.now() }));
      } catch (e) {}

      const discoveryUrl = NkSmartSearch.buildDiscoveryUrl(data, query);
      const fallbackUrl = '/search?q=' + encodeURIComponent((data && data.search_text) || query) + '&options[prefix]=last';
      window.location.href = discoveryUrl || fallbackUrl;
    } catch (error) {
      // Timeout or network error — navigate to plain search; overlay handles AI filtering
      window.location.href = '/search?q=' + encodeURIComponent(query) + '&options[prefix]=last';
    } finally {
      form.classList.remove('is-loading');
    }
  });

  /* ─────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────── */
  scheduleAutoExpand();
});
